import { timeFormatLocale } from "d3";

const apDateTimeLocale = timeFormatLocale({
  dateTime: "%x, %X",
  date: "%b %e, %Y",
  time: "%-I:%M %p ET",
  periods: ["a.m.", "p.m."],
  days: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
  shortDays: ["Sun.", "Mon.", "Tue.", "Wed.", "Thu.", "Fri.", "Sat."],
  months: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  shortMonths: [
    "Jan.",
    "Feb.",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug.",
    "Sept.",
    "Oct.",
    "Nov.",
    "Dec.",
  ],
});
const monYearFormat = apDateTimeLocale.format("%B %d");

export { apDateTimeLocale, monYearFormat };
